import { buildQueryParams, requestBuilder } from '../../../http/RequestBuilder';
import {
    type PaymentTransactionsTableResponse,
    type PaymentTransactionTableRequest,
} from '../../types/Transactions';

export const useGetPaymentTransactionTable = requestBuilder.query<
    PaymentTransactionsTableResponse,
    PaymentTransactionTableRequest
>({
    queryKey: ({ syncteraAccountId, ...query }) =>
        `paymentTransactionTable/${syncteraAccountId}${buildQueryParams(
            query,
        )}`,
    endpoint: ({ syncteraAccountId, ...query }) =>
        `/api/transactions/payments-table/${syncteraAccountId}${buildQueryParams(
            query,
        )}`,
});
